module.exports = __webpack_public_path__ + "img/Presentation38.900843e8.png";